export const COMPANY_NAME = "UB FINANCE ONLINE"
export const COMPANY_NAME_FULL = "UB FINANCE ONLINE"
export const BACKEND_ADDRESS = process.env.REACT_APP_BACKEND_ADDRESS
export const META_TITLE = "UB FINANCE MOBILE"
export const META_DESCRIPTION = "Welcome to UB FINANCE MOBILE"
export const META_IMAGE = "%PUBLIC_URL%/presentation.png"
export const META_URL = "https://ibanking.ubfinancemobile.net"
export const ENABLE_OTHER_DEPOSIT = false
